import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: string
  name: string
  email: string
  hasCompletedOnboarding?: boolean
  cold_start_completed?: boolean
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  hasCompletedOnboarding: boolean
  hasColdStartCompleted: boolean
  setAuth: (user: User, token: string) => void
  setUser: (user: User | null) => void
  setOnboardingComplete: (completed: boolean) => void
  setColdStartComplete: (completed: boolean) => void
  logout: () => void
  getToken: () => string | null
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      hasCompletedOnboarding: false,
      hasColdStartCompleted: false,
      setAuth: (user, token) => set({
        user,
        token,
        isAuthenticated: true,
        hasCompletedOnboarding: user.hasCompletedOnboarding || false,
        hasColdStartCompleted: user.cold_start_completed || false,
      }),
      setUser: (user) => set({
        user,
        isAuthenticated: !!user,
        hasCompletedOnboarding: user?.hasCompletedOnboarding || false,
        hasColdStartCompleted: user?.cold_start_completed || false,
      }),
      setOnboardingComplete: (completed) => set({ hasCompletedOnboarding: completed }),
      setColdStartComplete: (completed) => set({ hasColdStartCompleted: completed }),
      logout: () => set({ user: null, token: null, isAuthenticated: false, hasCompletedOnboarding: false, hasColdStartCompleted: false }),
      getToken: () => get().token,
    }),
    {
      name: 'auth-storage',
    }
  )
)
